import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { apiurl } from "../config/config";
import { motion } from "framer-motion";
import {
  FaArrowLeft,
  FaBan,
  FaUserSlash,
} from "react-icons/fa";
import Layout, { Container } from "../components/layout";
import { SuwasthiLoader } from "../components/loader";
import axios from "axios";
import { header } from "framer-motion/client";
import { getCookie } from "../config/webStorage";

const CandidateDetails = () => {
  const { candidateObjId } = useParams();
  const navigate = useNavigate();

  const [candidate, setCandidate] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showBlockModal, setShowBlockModal] = useState(false);
  const [blockReason, setBlockReason] = useState("");
  const [blocking, setBlocking] = useState(false);

  const fetchCandidate = async () => {
    try {
      const { data } = await axios.get(
        `${apiurl}/api/candidate/get/${candidateObjId}`
      );
      setCandidate(data?.candidate);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCandidate();
  }, [candidateObjId]);

  let token = getCookie("swtoken");

  const handleBlockCandidate = async () => {
    try {
      setBlocking(true);

await axios.post(
  `${apiurl}/api/candidate/bulk-block`,
  {
    aadharNumbers: [candidate.aadharNumber],
    reason: blockReason || "Blocked by HR",
  },
  {
    headers: {
      Authorization: token, // or `Bearer ${token}` if backend expects it
    },
  }
);


      setShowBlockModal(false);
      setBlockReason("");
      fetchCandidate();
    } catch (err) {
      alert("Failed to block candidate");
    } finally {
      setBlocking(false);
    }
  };

  if (loading) {
    return (
      <Layout>
        <SuwasthiLoader />
      </Layout>
    );
  }

  if (!candidate) {
    return <div className="text-center text-red-500">Candidate not found.</div>;
  }

  return (
    <Layout>
      <Container>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="min-h-screen bg-gray-50 p-6"
        >
          {/* Header */}
          <div className="flex justify-between items-center mb-6">
            <button
              onClick={() => navigate(-1)}
              className="flex items-center gap-2 text-blue-600 hover:text-blue-800"
            >
              <FaArrowLeft /> Back
            </button>

            {candidate.isBlocked && (
              <span className="bg-red-600 text-white px-4 py-1 rounded-full text-sm flex items-center gap-2">
                <FaUserSlash /> BLOCKED
              </span>
            )}
          </div>

          {/* Candidate Card */}
          <div className="bg-white rounded-2xl shadow p-6 mb-6">
            <div className="flex justify-between items-start">
              <div>
                <h2 className="text-2xl font-semibold">
                  {candidate.personalInfo.firstName}{" "}
                  {candidate.personalInfo.lastName}
                </h2>
                <p className="text-gray-500 text-sm">
                  Aadhaar: {candidate.aadharNumber}
                </p>
              </div>

              {!candidate.isBlocked && (
                <button
                  onClick={() => setShowBlockModal(true)}
                  className="bg-red-600 text-white px-4 py-2 rounded-lg flex items-center gap-2 hover:bg-red-700"
                >
                  <FaBan /> Block Candidate
                </button>
              )}
            </div>

            <div className="grid md:grid-cols-2 gap-4 mt-4 text-sm">
              <p><strong>Email:</strong> {candidate.personalInfo.email}</p>
              <p><strong>Phone:</strong> {candidate.personalInfo.phone}</p>
              <p><strong>Gender:</strong> {candidate.personalInfo.gender}</p>
              <p><strong>Marital Status:</strong> {candidate.personalInfo.maritalStatus}</p>
              <p className="md:col-span-2">
                <strong>Address:</strong> {candidate.personalInfo.currentAddress}
              </p>
            </div>
          </div>

          {/* Applications */}
          <h3 className="text-xl font-semibold mb-3">Applications</h3>
          <div className="grid md:grid-cols-2 gap-4">
            {candidate.appliedPositions.map((app, idx) => (
              <motion.div
                key={idx}
                whileHover={{ scale: 1.02 }}
                className="bg-white rounded-xl shadow p-5"
              >
                <h4 className="font-semibold">{app.positionTitle}</h4>
                <p className="text-sm text-gray-600">
                  Department: {app.department}
                </p>
                <p className="text-sm">
                  Status:{" "}
                  <span className="font-semibold">
                    {app.applicationStatus}
                  </span>
                </p>
                <p className="text-xs text-gray-500">
                  Applied on{" "}
                  {new Date(app.appliedDate).toLocaleDateString()}
                </p>
              </motion.div>
            ))}
          </div>

          {/* BLOCK MODAL */}
          {showBlockModal && (
            <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
              <div className="bg-white rounded-xl w-full max-w-md p-6">
                <h3 className="text-lg font-semibold mb-3">
                  Block Candidate
                </h3>

                <textarea
                  rows={4}
                  placeholder="Reason for blocking"
                  className="w-full border rounded-lg p-3 mb-4"
                  value={blockReason}
                  onChange={(e) => setBlockReason(e.target.value)}
                />

                <div className="flex justify-end gap-3">
                  <button
                    onClick={() => setShowBlockModal(false)}
                    className="px-4 py-2 border rounded-lg"
                  >
                    Cancel
                  </button>
                  <button
                    disabled={blocking}
                    onClick={handleBlockCandidate}
                    className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
                  >
                    {blocking ? "Blocking..." : "Confirm Block"}
                  </button>
                </div>
              </div>
            </div>
          )}
        </motion.div>
      </Container>
    </Layout>
  );
};

export default CandidateDetails;